export default [
  {
    question: 'ウォーク機能とはなんですか？',
    a:
      '歩いて週の目標歩数を4週分達成するとスタンプが1つもらえます。（1週間のタームは月曜日の0:00〜日曜日の23:59とします。）連続達成でなくても、4週分達成することで獲得できます。また、キャンペーン期間中はスタンプがいつもより多くもらえたり、週の目標歩数が変わることがあります。',
    id: '1'
  },
  {
    question: '1週間とはいつからいつですか?',
    a: '月曜日の0時から日曜日の23時59分59秒までが1週間となります。',
    id: '1-1'
  },
  {
    question: 'どのように利用するのですか？',
    a:
      'まず、ウォーク機能と端末の歩数計の連携をします。その後、スマートフォンを持って歩くと端末の歩数計に歩数がたまります。香の川製麺アプリでウォークページを開いた際に、都度、最新の歩数情報がアプリへ反映されます。アプリへのデータ反映は、最大過去7日分となりますので、こまめに反映するのをおすすめします。長期間ウォークページを開かない場合、歩数が連携されない日が出てくる可能性がありますので、ご注意ください。<br>（※ウォーク機能を開始する前日の歩数は反映されません。iOSは利用開始後の歩数から、Androidは利用開始日の歩数から反映されます。）',
    id: '2'
  },
  {
    question: 'ウォーク機能を利用するにはログインが必要ですか？',
    a:
      '通常はログインなしでご利用いただけます。<br>ただし、機種変更などで端末を変更された場合は、お使いのID/パスワードでログイン後、ウォーク機能の使用を開始してください。ただし、引き継ぎ日当日については、歩数の多い端末の歩数のみ反映されます。<br><br>また歩数は、香の川製麺アプリでウォークページを開いた際に、都度、最新の歩数情報がアプリへ反映されます。アプリへのデータ反映は、最大過去7日分となりますので、こまめに反映するのをおすすめします。長期間ウォークページを開かない場合、歩数が連携されない日が出てくる可能性がありますので、ご注意ください。<br>（※ウォーク機能を開始する前日の歩数は反映されません。iOSは利用開始後の歩数から、Androidは利用開始日の歩数から反映されます。）<br><br>ログインをするとスマートフォンの機種変更や再インストールをした際に、歩数データを引き継いで利用することができます。詳しくは[[[こちら:::inner/9]]]をご覧ください。',
    id: '3'
  },
  {
    question: '週の歩数の達成状況はどこで確認できますか？',
    a:
      '現在の歩数は、マイページ内にある「ウォーク機能」ボタンをタップし、表示される画面でその週（月〜日区切り）の歩数が表示されます。また、その下に、何週分達成しているかメーターが表示されます。<br>img:walk-q4n.png',
    id: '4'
  },
  {
    question: 'ウォーク機能で獲得したスタンプはどこで確認できますか？',
    a: 'スタンプページから確認できます。',
    id: '5'
  },
  {
    question:
      'ウォーク機能で獲得したスタンプも、他のスタンプ同様たまれば特典になりますか？',
    a: 'はい。他のスタンプと同様に特典獲得スタンプとしてカウントされます。',
    id: '6'
  },
  {
    question: '歩数がカウントされません',
    a:
      'はじめに、連携後の画面が表示されていることを確認してください。<br>img:walk-q7n.png<br>最新の歩数は、マイページ内にある「ウォーク機能」ボタンをタップし、ウォーク画面トップを表示するか、ウォーク画面内の「更新ボタン」を押すことで最新の歩数が反映されます。以上の動作でも歩数が更新されない場合、お使いの端末の歩数計データとの連携設定をご確認ください。<br>iOS/Androidとも1台の端末（アプリID）のみのデータと連携します。香の川製麺アプリでウォークページを開いた際に、都度、最新の歩数情報がアプリへ反映されます。アプリへのデータ反映は、最大過去7日分となりますので、こまめに反映するのをおすすめします。長期間ウォークページを開かない場合、歩数が連携されない日が出てくる可能性がありますので、ご注意ください。<br><br>※AndroidではGoogleFitで取得した歩数計データを利用します。連携するGoogleアカウントを変更した場合は、変更したGoogleアカウントのデータが以降反映されます。変更当日は、歩数の多いアカウントデータが反映されます。<br></br>また、端末のバッテリー消費を抑える設定（省電力モード・バッテリーセーバーなど）によっては、アプリのバックグラウンド機能が制御・終了され、歩数が計測できない場合があります。設定を解除していただくか、香の川製麺アプリを省電力モードの対象外にしてください。<br>Android8をお使いの場合、設定＞バッテリーから香の川製麺アプリを選択し、「バックグラウンドアクティビティ」をオンにしてください。<br></br>問題が解消しない場合は、下記よりお問い合わせください。<br>＜問い合わせボタン＞<br>',
    id: '7'
  },
  {
    question:
      'スマートフォン２台で香の川製麺アプリを利用しています。歩数を合算してカウントすることができますか？',
    a:
      '基本的にできません。引き継ぎをされた場合は、過去のデータについては引き継ぐことができますが、引き継ぎ日当日については、歩数データの大きいいずれかの端末のデータが反映されます。<br>ただし、Googleアカウントで連携している端末であれば、合算される場合がございます。',
    id: '8'
  },
  {
    question: '機種変更をしたのですが、歩数は引き継げますか？',
    a:
      'はい、引き継ぐことができます。<br>機種変更手続き後、歩数をカウントした新しい端末からお使いのID/パスワードでログインしてください。ただし、引き継ぎ日当日については、歩数の多い端末の歩数のみ反映されます。<br><br>その他、機種変更・再インストールについては[[[こちら:::/faq/model-change]]]をご覧ください。<br>',
    id: '9'
  },
  {
    question: 'ウォーク機能の利用をオフにするにはどうしたらいいですか？',
    a:
      '■iOSの場合<br>OSの設定画面から香の川製麺アプリを選択し、「モーションとフィットネス」のトグルをオフにしてください。<br>img:walk-q10n.png<br>■Androidの場合<br>Google Fitのアプリのプロフィール＞設定ボタン＞「接続済みのアプリを管理」から、香の川製麺アプリのアクセス権を削除してください。接続が切れるまでに1日程度かかる場合がございます。<br>img:walk-q10n.png',
    id: '10'
  },
  {
    question: 'ウォークスタンプの対応環境を教えてください。',
    a:
      '以下をご確認ください。<br><br>■iOS<br>iOS9.0以降の端末<br>※iPadおよびiPod touchでは動作を保証しておりません。<br><br>■Android<br>Android5以上の端末<br>※Android端末では、メーカー・機種によって、対応OSであっても動作しない・歩数の反映に時間がかかることがあります。',
    id: '11'
  },
  {
    question: 'Android端末で歩数のカウントがされません。',
    a:
      'Android端末をお使いの場合、Google Playストアより香の川製麺公式アプリを最新バージョンにアップデートの上、Google Fitのアプリをインストールしていただく必要があります。<br><br>アプリをインストールして頂いた上で、Google Fitのアプリ上で歩数のカウントを開始して頂くと、連携されている香の川製麺公式アプリのウォークスタンプ機能にも歩数が反映されます。<br>※香の川製麺アプリに連携したGoogleアカウントと同じGoogleアカウントを設定してください。<br>img:walk-q11-2.png<br><br>Google Fitアプリのインストールは[[[こちら:::ex/https://play.google.com/store/apps/details?id=com.google.android.apps.fitness]]]。<br><br>Google Fitとの連携方法については[[[こちら:::inner/13]]]をご確認ください。',
    id: '11-2'
  },
  {
    question: 'Google Fitとはなんですか？',
    a:
      'Google Fitとは、Google社が提供している、様々なアプリや端末のフィットネスデータを取得・管理できるサービスです。<br><br>[香の川製麺アプリとGoogle Fitの連携でできること]<br>・手軽で、最小限の電力消費で利用可能<br>Google Fit連携開始に、追加アプリのインストールは不要です。<br>Android端末にプリインストールされているアプリを利用するため、手軽に、かつ電力消費も最小限に連携することができます。<br><br>・ウエアラブル端末でも連携できる<br>同じGoogleアカウントでログインしているウエアラブル端末等、様々な端末での歩数が反映される場合があります。香の川製麺アプリでは、連携したGoogleアカウントの歩数を正として歩数を反映します。<br>※各端末をGoogle Fitと連携する必要があります。<br>設定方法は各メーカーにお問い合わせください。<br><br>Google Fitに関連する詳細情報はGoogle社が提供するページをご確認ください。<br>詳細は[[[こちら:::ex/https://support.google.com/accounts/answer/6098255]]]',
    id: '12'
  },
  {
    question: 'Google Fitとの連携方法を教えてください。',
    a:
      '[Google Fitとの連携方法]<br>1:ウォークタブに遷移し、表示されるダイアログで「はい」を選択する。<br><br>2:利用するGoogleアカウントを選択し、リクエストを許可。<br>img:walk-q13.png<br><br>※Google Fitと香の川製麺アプリの連携には、追加アプリのインストールは不要です。<br><br>Android端末にプリインストールされている、『GooglePlay開発者サービス』アプリを利用します。Android端末にて[[[こちら:::ex/https://play.google.com/store/apps/details?id=com.google.android.gms]]]をタップして、最新版がインストールされているかご確認ください。（最新版がインストールされている場合「無効化」と表示されます。）',
    id: '13'
  },
  {
    question:
      'Google Fitとの連携に、Google Fitアプリのインストールは必要ですか？',
    a:
      'Google Fitと香の川製麺アプリの連携には、追加アプリのインストールは不要です。Android10以上の端末にGoogle Fitがインストールされていない場合、「身体活動」へのアクセス許可が必要です。画面表示の案内に従い許可をしてください。<br><br>Android端末にプリインストールされている、『GooglePlay開発者サービス』アプリを利用します。Android端末にて[[[こちら:::ex/https://play.google.com/store/apps/details?id=com.google.android.gms]]]をタップして、最新版がインストールされているかご確認ください。（最新版がインストールされている場合「無効化」と表示されます。）<br><br>※追加インストール不要でお使いいただけますが、Google Fitアプリをインストールすると、歩数精度が向上します。',
    id: '14'
  },
  {
    question: 'Google Fitと連携したら歩数が正しく計測されません。',
    a:
      'Google Fitのデータが正しく香の川製麺アプリと連携されているかご確認ください。詳しくは[[[こちら:::ex/https://support.google.com/accounts/answer/6098255]]]をご確認ください。<br><br>問題が解決されない場合、Google社提供の[[[Google fitヘルプ:::ex/https://support.google.com/fit/topic/6090203]]]「問題を解決する」を参照ください。',
    id: '15'
  },
  {
    question: 'Google Fitと連携したら電池消費が早くなりました。',
    a:
      'Google Fitは、Android端末にプリインストールされている、『GooglePlay開発者サービス』アプリを利用します。まれに『GooglePlay開発者サービス』に起因して、異常に電池消費が早くなったり、端末が発熱したりする事象がございます。下記をお試しください。<br><br>[『Google Play開発者サービス』のアップデート]<br>1: Android端末から[[[こちら:::ex/https://play.google.com/store/apps/details?id=com.google.android.gms]]]のリンクをタップ。<br>2: 「アップデート」ボタンからアップデートしてください。<br>※「無効化」と表示されている場合、最新版がインストールされているためアップデートは不要です。<br><br>[『Google Play開発者サービス』のキャッシュ削除]<br>アップデートでも改善されない場合、下記をお試しください。<br>1: 設定＞アプリ＞全てのアプリ＞Google Play開発者サービスをタップ。<br>2: Android5.0以前の場合、画面下部にある「キャッシュを消去」をタップ。Android 6.0以降の場合、アプリ情報の中にある「ストレージ」より「キャッシュを消去」をタップしてください。<br><br>[『Google Play開発者サービス』のデータを削除]<br>キャッシュ削除でも改善されない場合、下記をお試しください。<br>1: 設定＞アプリ＞全てのアプリ＞Google Play開発者サービスをタップ。<br>2: Android5.0以前の場合、「容量を管理」をタップし、「データを全て消去」をタップしてください。Android 6.0以降の場合、アプリ情報の中にある「データを全て消去」をタップしてください。<br>※こちらを実施した場合、Googleが提供しているアプリやサービスの再ログインが必要になります。<br><br>Google社提供の[[[Google fitヘルプ:::ex/https://support.google.com/fit/topic/6090203?visit_id=1-636681199039206908-3995083634]]]「問題を解決する」を参照ください。',
    id: '16'
  },
  {
    question: 'カウントされていた歩数がカウントされなくなった。',
    a:
      'ウォーク機能は、スマホ本体の歩数計データをもとに歩数をカウントしており、香の川製麺アプリのウォークページを起動した時に取得しています。この歩数計データの読み込みは起動から過去最大7日間の歩数までさかのぼって取得できますが、7日以上ウォークページの起動がない場合は、歩数がカウントされません。<br><br>また、ご利用の端末がAndroidの場合、OSのバージョンアップによってGoogle Fitとの連携が解除され、歩数カウントができない場合がございます。再度Google Fitとの連携をご確認ください。<br>詳しくは[[[こちら:::inner/13]]]をご確認ください。',
    id: '17'
  },
  {
    question: 'ウエアラブル端末で利用できますか？',
    a:
      '利用できません。あらかじめご了承ください。<br>※ただし、Androidの端末によっては同じGoogleアカウントで連携されている場合、ウエアラブル端末の歩数も合算される場合があります。香の川製麺アプリでは、連携したGoogleアカウントの歩数を正として歩数を反映します。',
    id: '18'
  },
  {
    question:
      '歩いた歩数が反映されていないのですが、どうすれば良いでしょうか？',
    a:
      '歩数がカウントされない場合は、いくつかの原因が考えられます。ご利用の端末が下記の条件に当てはまらないか今一度ご確認ください。<br><br>■Google Fitとの連携が解除されている（Androidの場合）<br>Android端末をお使いの方はGoogleFitとの連携を確認ください。Google Fitの連携は[[[こちら:::inner/13]]]からご確認ください。<br><br>■Google Fit(Android）と歩数が違う<br>ウォーク画面に遷移し、「更新」ボタンをタップして歩数を更新してください。<br>img:walk-q19n.png<br><br>■AndroidのOSのバージョンをアップデートした場合<br>再度Google Fitとの連携を確認ください。OSバージョンアップによって連携が解除される場合がございます。',
    id: '19'
  },
  {
    question:
      'スタンプゲットをしたのに「現在の達成週数が表示されるメーター」に最新データが反映されずメーターがリセットされません。',
    a:
      '「現在の達成週数が表示されるメーター」に最新データが反映されてメーターがリセットされるのは、基本的には毎週月曜0:00のタイミングとなります。 ただし、前週以前に達成していたスタンプを当該週で連携して獲得した場合、当該週の歩数を達成したタイミングでメーターのリセットがかかります。当該週の歩数を達成しなかった場合は、次の月曜の0:00のタイミングでメーターの更新がかかります。',
    id: '20'
  }
]